const SITE_URL = "https://bezierclick.com";
const { servicePages } = require("./service-pages.js");
const { localServicePages } = require("./local-service-pages.js");
const { DEFAULT_PROJECTS } = require("./portfolio-data.js");
const { insightArticles } = require("./insights.js");

const makeRouteSeo = (path, title, description, extras = {}) => {
  const url = `${SITE_URL}${path === "/" ? "" : path}`;
  return {
    title,
    description,
    canonical: url,
    ogUrl: url,
    ...extras,
  };
};

const serviceRouteSeo = Object.fromEntries(
  servicePages.map((page) => [
    page.path,
    makeRouteSeo(page.path, page.title, page.description),
  ])
);

const localRouteSeo = Object.fromEntries(
  localServicePages.map((page) => [
    page.path,
    makeRouteSeo(page.path, page.title, page.description),
  ])
);

const projectRouteSeo = Object.fromEntries(
  DEFAULT_PROJECTS.map((project) => [
    project.casePath,
    makeRouteSeo(
      project.casePath,
      `${project.title} case study | BezierClick`,
      `Case study do projeto ${project.title}: contexto, problema, solucao e resultado do trabalho digital desenvolvido pela BezierClick.`
    ),
  ])
);

const insightRouteSeo = Object.fromEntries(
  insightArticles.map((article) => [
    article.path,
    makeRouteSeo(article.path, article.title, article.description),
  ])
);

const routeSeo = {
  "/": makeRouteSeo(
    "/",
    "BezierClick | Web, sistemas e automação para empresas",
    "Websites, sistemas, automações e suporte tecnológico para empresas em Portugal venderem melhor e operarem com menos trabalho manual."
  ),
  "/solucoes": makeRouteSeo(
    "/solucoes",
    "Soluções digitais | BezierClick",
    "Soluções de websites, ecommerce, software à medida, automação, IA e integrações para resolver problemas reais de empresas."
  ),
  "/planos": makeRouteSeo(
    "/planos",
    "Planos e preços | BezierClick",
    "Planos de websites, ecommerce, automação e suporte recorrente com valores claros para empresas que querem investir em tecnologia."
  ),
  "/tech-partner": makeRouteSeo(
    "/tech-partner",
    "Tech Partner para PMEs | BezierClick",
    "Acompanhamento tecnológico recorrente para evoluir websites, sistemas, automações e integrações sem contratar uma equipa interna."
  ),
  "/projetos": makeRouteSeo(
    "/projetos",
    "Projetos digitais | BezierClick",
    "Conheça projetos e exemplos de websites, sistemas e experiências digitais criadas pela BezierClick para empresas."
  ),
  "/insights": makeRouteSeo(
    "/insights",
    "Insights sobre websites, SEO e automação | BezierClick",
    "Guias práticos da BezierClick sobre websites, SEO, software, automação, IA e Tech Partner para PMEs em Portugal."
  ),
  "/contacto": makeRouteSeo(
    "/contacto",
    "Contacto | BezierClick",
    "Fale com a BezierClick sobre websites, sistemas, automações, IA ou acompanhamento tecnológico para a sua empresa."
  ),
  "/diagnostico-digital": makeRouteSeo(
    "/diagnostico-digital",
    "Diagnóstico Digital Gratuito | BezierClick",
    "Peça um diagnóstico digital gratuito para perceber que website, sistema, automação ou integração pode ajudar a sua empresa a crescer."
  ),
  "/404": makeRouteSeo(
    "/404",
    "Página não encontrada | BezierClick",
    "A página que procura não foi encontrada. Volte às soluções, projetos, insights ou peça um diagnóstico digital gratuito.",
    { robots: "noindex,follow" }
  ),
  ...serviceRouteSeo,
  ...localRouteSeo,
  ...projectRouteSeo,
  ...insightRouteSeo,
};

const getRouteSeo = (pathname) => routeSeo[pathname] || routeSeo["/404"];

const setContent = (documentRef, selector, value) => {
  const node = documentRef.querySelector?.(selector);
  if (node) node.content = value;
};

const applyRouteSeo = (pathname, documentRef = typeof document !== "undefined" ? document : null) => {
  if (!documentRef) return;

  const metadata = getRouteSeo(pathname);
  documentRef.title = metadata.title;
  setContent(documentRef, 'meta[name="description"]', metadata.description);
  setContent(documentRef, 'meta[property="og:title"]', metadata.title);
  setContent(documentRef, 'meta[property="og:description"]', metadata.description);
  setContent(documentRef, 'meta[property="og:url"]', metadata.ogUrl);
  setContent(documentRef, 'meta[name="twitter:title"]', metadata.title);
  setContent(documentRef, 'meta[name="twitter:description"]', metadata.description);
  setContent(documentRef, 'meta[name="robots"]', metadata.robots || "index,follow");

  const canonical = documentRef.querySelector?.('link[rel="canonical"]');
  if (canonical) canonical.href = metadata.canonical;
};

module.exports = {
  routeSeo,
  getRouteSeo,
  applyRouteSeo,
};
